var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_2163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.3529 8.11763V7.41175C6.3529 6.43867 5.56127 5.64705 4.58819 5.64705C4.39356 5.64705 4.23525 5.48874 4.23525 5.29411V4.58822C4.23525 4.39359 4.39356 4.23528 4.58819 4.23528H6.3529V2.82352H4.58819C3.61511 2.82352 2.82349 3.61514 2.82349 4.58822V5.29411C2.82349 6.26719 3.61511 7.05881 4.58819 7.05881C4.78283 7.05881 4.94113 7.21712 4.94113 7.41175V8.11763C4.94113 8.31227 4.78283 8.47058 4.58819 8.47058H2.82349V9.88234H4.58819C5.56127 9.88234 6.3529 9.09072 6.3529 8.11763Z",
    fill: "#2DD4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2352 8.47058H14.1176V2.82352H12.7058V9.88234H16.2352V8.47058Z",
    fill: "#2DD4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1764 8.47058H19.0587V2.82352H17.647V9.88234H21.1764V8.47058Z",
    fill: "#2DD4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2941 8.47058H9.17641V7.05881H10.5882V5.64705H9.17641V4.23528H11.2941V2.82352H7.76465V9.88234H11.2941V8.47058Z",
    fill: "#2DD4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V21.1765H8.27242L7.91948 22.5882H5.64706V24H18.3529V22.5882H16.0805L15.7276 21.1765H24V0ZM9.37464 22.5882L9.72758 21.1765H14.2724L14.6254 22.5882H9.37464ZM22.5882 19.7647H1.41176V18.3529H22.5882V19.7647ZM22.5882 16.9412H1.41176V1.41176H22.5882V16.9412Z",
    fill: "#2DD4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47055 11.2941H2.82349V15.5294H8.47055V11.2941ZM7.05878 14.1177H4.23525V12.7059H7.05878V14.1177Z",
    fill: "#2DD4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5293 15.5294H21.1764V11.2941H15.5293V15.5294ZM16.9411 12.7059H19.7646V14.1177H16.9411V12.7059Z",
    fill: "#2DD4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88232 11.2941H14.1176V12.7059H9.88232V11.2941Z",
    fill: "#2DD4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88232 14.1176H14.1176V15.5294H9.88232V14.1176Z",
    fill: "#2DD4BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_2163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSell);
export default __webpack_public_path__ + "static/media/Sell.4d965dceb4fc6fb125ad24f29845c092.svg";
export { ForwardRef as ReactComponent };